module.exports = __webpack_public_path__ + "static/img/businessPlan.2cba15e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/businessPlan.jpg
// module id = Iy+i
// module chunks = 1